export default __webpack_public_path__ + "static/aiPageHeroSection-81a52d07bdbec3902b53133b54971dc6.webm";